import { useEffect, useRef } from 'react';
import { useMediaQuery } from 'usehooks-ts';
import { CaretLeft } from '@phosphor-icons/react';
import { breakpoints, Heading } from '@etg/wings';
import { css, cx, resetButtonStyle } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { getCloseButtonStyles, headerWrapperStyles, OverlayHeader } from './OverlayComponents';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const headContainerStyle = css`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;
const buttonStyle = css`
  position: relative;
`;
const headStyle = css`
  line-height: normal;
`;
export const OverlayHeaderWithBackButton = ({
  ariaLabel,
  className,
  dialogCloseButtonAriaLabel,
  onClose,
  journeyType,
  title
}) => {
  const {
    t
  } = useTranslation();
  const isTabletOrDesktop = useMediaQuery(`(min-width: ${breakpoints._768})`);
  const buttonref = useRef(null);
  useEffect(() => {
    if (buttonref.current) {
      buttonref.current.focus({
        preventScroll: true
      });
    }
  }, []);
  return isTabletOrDesktop ? /*#__PURE__*/_jsx(OverlayHeader, {
    onClose: onClose,
    title: title
  }) : /*#__PURE__*/_jsxs("header", {
    className: cx(headerWrapperStyles, className),
    children: [onClose && /*#__PURE__*/_jsx("button", {
      "aria-label": dialogCloseButtonAriaLabel !== null && dialogCloseButtonAriaLabel !== void 0 ? dialogCloseButtonAriaLabel : t('ScreenReader.CloseButtonDialog.AriaLabel.Text'),
      className: cx(resetButtonStyle, getCloseButtonStyles, buttonStyle),
      "data-testid": "overlay-close",
      onClick: onClose,
      ref: buttonref,
      type: "button",
      children: /*#__PURE__*/_jsx(CaretLeft, {
        "aria-hidden": true,
        size: 24,
        weight: "light"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: headContainerStyle,
      children: [/*#__PURE__*/_jsx(Heading, {
        "aria-label": ariaLabel,
        className: headStyle,
        level: 2,
        children: title
      }), journeyType]
    })]
  });
};
//# sourceMappingURL=OverlayComponentsBackButton.js.map